// WhyConsultFirst.jsx
import React from 'react';
import {
  AlertCircle,
  CheckCircle,
  XCircle,
  ArrowRight,
  Sparkles,
  Shield,
  Zap,
  TrendingUp,
  Clock,
  DollarSign,
  Cpu,
  Users,
  Lightbulb,
  Target,
  BarChart3,
  ThumbsUp,
  ThumbsDown,
  ChevronRight,
  Info,
  Award
} from 'lucide-react';
import './WhyConsultFirst.css';
import CTA from'./CTA';

const WhyConsultFirst = () => {
  const withoutExpert = [
    { text: "Design errors", icon: XCircle },
    { text: "Manufacturing challenges", icon: XCircle },
    { text: "Wrong material selection", icon: XCircle },
    { text: "High prototype cost", icon: XCircle },
    { text: "Repeated redesign", icon: XCircle },
    { text: "Delays", icon: XCircle },
    { text: "Unnecessary machine selection", icon: XCircle }
  ];

  const withExpert = [
    { text: "Better design", icon: CheckCircle },
    { text: "Improved manufacturability", icon: CheckCircle },
    { text: "Right material", icon: CheckCircle },
    { text: "Better manufacturing process", icon: CheckCircle },
    { text: "Lower development risk", icon: CheckCircle },
    { text: "Reduced cost", icon: CheckCircle },
    { text: "Faster prototype development", icon: CheckCircle }
  ];

  const benefits = [
    {
      icon: Shield,
      title: "Risk Reduction",
      description: "Identify potential issues before they become costly problems"
    },
    {
      icon: DollarSign,
      title: "Cost Savings",
      description: "Avoid expensive mistakes and optimize your budget"
    },
    {
      icon: Clock,
      title: "Faster Development",
      description: "Streamline your prototyping process with expert guidance"
    },
    {
      icon: Target,
      title: "Right Decisions",
      description: "Make informed choices about materials, processes, and design"
    }
  ];

  return (
    <section className="why-consult">
      <div className="why-consult-container">
        {/* ========== HEADER ========== */}
        <div className="why-consult-header">
          <div className="why-consult-badge">
            <Sparkles size={16} />
            <span>Expert Guidance</span>
          </div>
          <h1 className="why-consult-title">
  <span className="why-consult-title-line1">Why Consult</span>{" "}
  <span className="why-consult-title-line2">First?</span>
</h1>
          <p className="why-consult-subtitle">
            Avoid expensive mistakes before you build.
          </p>
          <p className="why-consult-description">
            Developing a prototype without technical guidance can lead to unnecessary redesigns, 
            unsuitable materials, expensive processes and delays. An expert consultation helps 
            you make better decisions before committing time and money.
          </p>
        </div>

        {/* ========== COMPARISON SECTION ========== */}
        <div className="why-consult-comparison">
          {/* Without Expert Guidance */}
          <div className="why-consult-column without">
            <div className="why-consult-column-header">
              <div className="why-consult-column-icon">
                <ThumbsDown size={24} />
              </div>
              <h3 className="why-consult-column-title">Without Expert Guidance</h3>
            </div>
            <ul className="why-consult-column-list">
              {withoutExpert.map((item, index) => {
                const Icon = item.icon;
                return (
                  <li key={index} className="why-consult-item negative">
                    <Icon size={18} className="why-consult-item-icon negative" />
                    <span>{item.text}</span>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* VS Divider */}
          <div className="why-consult-vs">
            <div className="why-consult-vs-line"></div>
            <div className="why-consult-vs-badge">VS</div>
            <div className="why-consult-vs-line"></div>
          </div>

          {/* With Expert Guidance */}
          <div className="why-consult-column with">
            <div className="why-consult-column-header">
              <div className="why-consult-column-icon positive">
                <ThumbsUp size={24} />
              </div>
              <h3 className="why-consult-column-title">With Expert Guidance</h3>
            </div>
            <ul className="why-consult-column-list">
              {withExpert.map((item, index) => {
                const Icon = item.icon;
                return (
                  <li key={index} className="why-consult-item positive">
                    <Icon size={18} className="why-consult-item-icon positive" />
                    <span>{item.text}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        {/* ========== BENEFITS SECTION ========== */}
        <div className="why-consult-benefits">
          <div className="why-consult-benefits-header">
            <div className="why-consult-section-badge">
              <Award size={14} />
              <span>Key Benefits</span>
            </div>
            <h2 className="why-consult-benefits-title">
              Why <span>Expert Consultation</span> Matters
            </h2>
          </div>

          <div className="why-consult-benefits-grid">
            {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <div key={index} className="why-consult-benefit-card">
                  <div className="why-consult-benefit-icon">
                    <Icon size={24} />
                  </div>
                  <h4 className="why-consult-benefit-title">{benefit.title}</h4>
                  <p className="why-consult-benefit-desc">{benefit.description}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* ========== CTA SECTION ========== */}
       <CTA/>

        {/* ========== STATS BAR ========== */}
        
      </div>
    </section>
  );
};

export default WhyConsultFirst;